<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container">
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>{{$router.currentRoute.meta.title}}</h3>
                    </div>
                      

                    <!-- Row -->
                    <div class="row">
                        
                        <div class="col-xl-12">
                            <div class="dashboard-box margin-top-0">

                                <div class="content with-padding padding-bottom-0 padding-top-0">

                                    <div class="row">

                                        <div class="col-xs-12" v-if="detalhes">
                                            <h5 class="margin-bottom-15">
                                                <i class="material-icons">info_outline</i>
                                                Informações:
                                            </h5>
                                            <div class="submit-field">
                                                <h4 v-if="$root.user.tipo == 'contratante'" class="margin-bottom-0">{{detalhes.NM_PACIENTE}}</h4>
                                                <h4 v-if="$root.user.tipo != 'contratante'" class="margin-bottom-0"><router-link :to="{'name': 'Paciente', 'query': {'CD_PESSOA_FISICA': detalhes.CD_PESSOA_FISICA}}"><u>{{detalhes.NM_PACIENTE}}</u></router-link></h4>
                                                <small class="block margin-bottom-20" style="line-height: 150%; padding-left: 10px;">
                                                    - Consulta: <b>{{detalhes.NR_SEQUENCIA}}</b>
                                                    <br>- Código paciente: <b>{{detalhes.CD_PESSOA_FISICA}}</b>
                                                    <br>- Responsável: <b>{{detalhes.NM_MEDICO_AGENDA}}</b>
                                                    <br>- Especialidade: <b>{{detalhes.DS_COMPLEMENTO}}</b>
                                                    <br>- Agendamento: <b>{{detalhes.HR_INICIO | formatDateTime}}</b>
                                                    <br>- Situação: 
                                                    <span class="dashboard-status-button color-orange" v-if="detalhes.TELECONSULTA.objeto.status == 0">Pendente</span>
                                                    <span class="dashboard-status-button color-yellow" v-if="detalhes.TELECONSULTA.objeto.status == 1">Aguardando paciente</span>
                                                    <span class="dashboard-status-button color-blue" v-if="detalhes.TELECONSULTA.objeto.status == 2">Em consulta</span>
                                                    <span class="dashboard-status-button color-green" v-if="detalhes.TELECONSULTA.objeto.status == 3">Realizada</span>
                                                </small>
                                            </div>
                                        </div>

                                        <div class="col-xs-12" v-if="detalhes">
                                            
                                            <button class="button green margin-bottom-10 block-mobile" type="button" v-on:click="iniciar()" v-if="detalhes.TELECONSULTA.objeto.status == 0 && $root.user.tipo == 'profissional'">
                                                <i class="material-icons">play_circle_outline</i>
                                                Abrir videoconferência
                                            </button>
                                            <button class="button green margin-bottom-10 block-mobile" type="button" v-on:click="iniciar()" v-if="detalhes.TELECONSULTA.objeto.status == 1 && $root.user.tipo == 'profissional'">
                                                <i class="material-icons">play_circle_outline</i>
                                                Abrir videoconferência
                                            </button>                                            
                                            <button class="button green margin-bottom-10 block-mobile" type="button" v-on:click="iniciar()" v-if="detalhes.TELECONSULTA.objeto.status == 2 && $root.user.tipo == 'profissional'">
                                                <i class="material-icons">play_circle_outline</i>
                                                Abrir videoconferência
                                            </button>                                            

                                            <button class="button green margin-bottom-10 block-mobile" type="button" v-on:click="iniciar()" v-if="detalhes.TELECONSULTA.objeto.status == 1 && $root.user.tipo == 'contratante'">
                                                <i class="material-icons">play_circle_outline</i>
                                                Abrir videoconferência
                                            </button>

                                            <button class="button green margin-bottom-10 block-mobile" type="button" v-on:click="iniciar()" v-if="detalhes.TELECONSULTA.objeto.status == 2 && $root.user.tipo == 'contratante'">
                                                <i class="material-icons">play_circle_outline</i>
                                                Abrir videoconferência
                                            </button>                                            

                                            <button class="button color-orange margin-bottom-10 block-mobile" type="button" v-on:click="finalizar()" v-if="detalhes.TELECONSULTA.objeto.status == 2 && $root.user.tipo == 'profissional'">
                                                <i class="material-icons">check_circle</i>
                                                Concluir atendimento
                                            </button>                                            

                                            <div class="chamada-video" style="" v-if="!cordova && detalhes.TELECONSULTA.objeto.status < 3">
                                                <div class="content" style="width: 100%;">
                                                    <div id="remote-media" v-show="chamada"></div>
                                                    <div id="local-media" v-show="chamada"></div>
                                                </div>

                                                <button v-show="chamada" class="mute-audio" v-on:click="muteAudio()">
                                                    <i class="material-icons" v-show="!mute.audio">mic_off</i>
                                                    <i class="material-icons" v-show="mute.audio">mic</i>
                                                </button>
                                                <button v-show="chamada" class="mute-video" v-on:click="muteVideo()">
                                                    <i class="material-icons" v-show="!mute.video">videocam_off</i>
                                                    <i class="material-icons" v-show="mute.video">videocam</i>
                                                </button>                                       
                                            </div>                                            
                                        </div>                                            

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name: 'Teleconsulta',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    data () {
        var self                    = this;
        return {
            "mute": {
                "audio": false,
                "video": false,
            },
            "realtime":             {},
            "detalhes":             null,
            "chamada":              null,
            "form": {
                "_cod":             "",
                "_token":           "",
                "CD_PESSOA_FISICA": "",
                "NR_SEQUENCIA":     ""
                
            }            
        }
    },
    filters: {
        formatDateTime: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            d = time.split(":");
            time = d[0] + ":" + d[1];

            return date + " " + time;
        },      
    },
    watch: {
       
    },
    methods: {
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            // loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "NR_SEQUENCIA": self.$route.query.NR_SEQUENCIA
                    }
                };

                axios.get("api/teleconsulta.php", form)
                .then(response => {
                    
                    console.log("get() response", response);
                    
                    // self.detalhes       = response.data.result;
                    self.setConsulta(response.data.result);
                    self.loaded         = true;
                    // loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    // loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    // if (error.response) {
                    //     if (error.response.status == 404) {
                    //         self.$root.back();
                    //     }
                    // }                    
                });   
            });   
        },
        setConsulta: function(obj) {
            var self = this;
            console.log("setConsulta()", obj);
            self.detalhes = obj;
            self.$forceUpdate();
            if (obj.TELECONSULTA.objeto.status == 3 && self.chamada) {
                console.log("Fim teleconsulta")
                window.__track.stop();
                window.__room.disconnect();
                self.chamada = null;
                self.realtime.client.disconnect();
                self.$forceUpdate();
                window.twiliovideo.closeRoom();                
                // self.initChamada(obj.TELECONSULTA.objeto.twilioToken, obj.NR_SEQUENCIA);
            }
        },
        initRealTime: function() {
            var self                = this;
            Pusher.logToConsole     = false;
            self.realtime.client    = new Pusher(self.$root.config.pusher.key, {
                cluster:            'us2',
                activityTimeout: 2000,
                // enabledTransports: ['ws']                    
            });
            self.realtime.channel   = self.realtime.client.subscribe("consulta-" + self.detalhes.NR_SEQUENCIA);
            self.realtime.channel.bind("update", function(data) {
                if (data.consulta) {
                    self.setConsulta(data.consulta);
                }
            });
            self.realtime.channel   = self.realtime.client.subscribe("chamada-" + self.detalhes.NR_SEQUENCIA + "-" + self.$root.user.cod);
            self.realtime.channel.bind("update", function(data) {
                if (data.tipo == "token") {
                    self.initChamada(data.token, data.room);
                }
                if (data.tipo == "fim") {
                }
            });             
        },
        muteAudio: function() {
            var self = this;
            if (!self.mute.audio) {
                self.room.localParticipant.audioTracks.forEach((publication) => { 
                    publication.track.disable(); 
                });
                self.mute.audio = true;
            } else {
                self.room.localParticipant.audioTracks.forEach((publication) => { 
                    publication.track.enable(); 
                });                 
                self.mute.audio = false;
            }
            self.$forceUpdate();
        },
        muteVideo: function() {
            var self = this;
            if (!self.mute.video) {
                self.room.localParticipant.videoTracks.forEach((publication) => { 
                    publication.track.disable(); 
                });
                self.mute.video = true;
            } else {
                self.room.localParticipant.videoTracks.forEach((publication) => { 
                    publication.track.enable(); 
                });                 
                self.mute.video = false;
            }
            self.$forceUpdate();
        },          
        iniciar: function() {
            var self        = this;
            console.log("iniciar()")
            loading.show();
            var form = {
                "_cod":         self.$root.user.cod, 
                "_token":       self.$root.user.token,
                "NR_SEQUENCIA": self.$route.query.NR_SEQUENCIA,
                "acao":         "iniciar"
            }
            
            axios.put("api/teleconsulta.php", form)
            .then(response => {

                console.log("iniciar()", "success", response.data)
                loading.hide();
                // alert(response.data.message);

            })
            .catch(error => {

                console.log("iniciar()", "error", error.data)
                loading.hide();
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));

            });            
        },    
        finalizar: function() {
            var self        = this;
            console.log("finalizar()")
            loading.show();
            var form = {
                "_cod":         self.$root.user.cod, 
                "_token":       self.$root.user.token,
                "NR_SEQUENCIA": self.$route.query.NR_SEQUENCIA,
                "acao":         "finalizar"
            }
            
            axios.put("api/teleconsulta.php", form)
            .then(response => {

                console.log("finalizar()", "success", response.data)
                loading.hide();
                alert(response.data.message);

            })
            .catch(error => {

                console.log("finalizar()", "error", error.data)
                loading.hide();
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));

            });            
        },                
        openChamada: function() {
            console.log("openChamada()");
            var self                = this;
            window.twiliovideo.openRoom(self.chamada.token, self.chamada.room, function(e) {
                console.log("initChamada() -> onEvent()", e);
            }, {
                "primaryColor":     "#00bcb4",
                "secondaryColor":   "#00bcb4",
                "handleErrorInApp": true,
                // "hangUpInApp":      true
            });
            // self.$app.preloader.hide();
        },        
        checkPermissions: function() {
            console.log("checkPermissions()");
            if (window.device) {
                if (window.device.platform === "Android") {
                    window.cordova.plugins.permissions.requestPermissions([window.cordova.plugins.permissions.CAMERA, window.cordova.plugins.permissions.RECORD_AUDIO, window.cordova.plugins.permissions.MODIFY_AUDIO_SETTINGS]);            
                }   
            }
            if (window.cordova && window.cordova.plugins && window.cordova.plugins.backgroundMode) {
                window.cordova.plugins.backgroundMode.enable();
            }                          
        },        
        initChamada: function(token, room) {
            var self        = this;
            console.log("initChamada()", token, room);

            self.chamada    = {
                "token":    token,
                "room":     room
            };

            self.$forceUpdate();

            window.__chamada = self.chamada;

            if (!window.device) window.device = {};
            if (window.device.platform == "iOS" || window.device.platform == "Android") {
        
                self.openChamada();
                return false;
            } 

            $(".dashboard-content-inner")[0].scrollTo({
                top:    $(".dashboard-content-inner").height()
            });     

            var Video = Twilio.Video;
            Video.createLocalVideoTrack().then(track => {
                var localMediaContainer = document.getElementById('local-media');
                window.__track = track;
                localMediaContainer.appendChild(track.attach());
            });

            Video.connect(token, {
                name:           room,
                bundlePolicy:   'max-compat'
            }).then(room => {
                console.log(`Successfully joined a Room: ${room}`);

                loading.hide();

                self.room   = room;
                window.__room = room;
                // _room       = room;

                var remoteMediaContainer = document.getElementById('remote-media');
                    room.participants.forEach(function(participant) {
                    console.log("Already in Room: '" + participant.identity + "'");
                    participantConnected(participant, remoteMediaContainer);
                });

                room.on('participantConnected', participant => {
                    console.log(`A remote Participant connected: ${participant}`);
                    participantConnected(participant);
                });

                room.on('participantDisconnected', participant => {
                    console.log(`A remote Participant connected: ${participant}`);
                    participantDisconnected(participant);
                });

            }, error => {
                loading.hide();
                console.error(`Unable to connect to Room: ${error.message}`);
            });

            function participantConnected(participant) {
                console.log('Participant "%s" connected', participant.identity);
                const div   = document.createElement('div');
                div.id      = participant.sid;
                participant.on('trackSubscribed', (track) => {
                    trackSubscribed(div, track)
                });
                participant.on('trackUnsubscribed', trackUnsubscribed);
                participant.tracks.forEach(publication => {
                    if (publication.isSubscribed) {
                        trackSubscribed(div, publication.track);
                    }
                });

                document.getElementById('remote-media').appendChild(div);
            }

            function participantDisconnected(participant) {
                console.log('Participant "%s" disconnected', participant.identity);

                var div     = document.getElementById(participant.sid)
                if (div) {
                    div.remove();
                }
            }

            function trackSubscribed(div, track) {
                div.appendChild(track.attach());
            }

            function trackUnsubscribed(track) {
                track.detach().forEach(element => element.remove());
            }

        },             
    },    
    created: function() {
        var self = this;
        console.log("created", self);

        self.cordova = window.cordova;

        self.form.NR_SEQUENCIA =  self.$route.query.NR_SEQUENCIA;
        // if (!self.$route.query.NR_SEQUENCIA) {
        //     self.$root.back();
        //     return false;
        // }

        self.checkPermissions();

        loading.show();

        Promise.all([
            self.get()
        ]).then(function() {
        
            self.initRealTime();
            setTimeout(function() {
                loading.hide();
            }, 500);
            
        }).catch(function(error) {
            loading.hide();
        });  

    },
    beforeDestroy: function () {
        console.log("Teleconsulta beforeDestroy");
        var self = this;
        window.__track.stop();
        window.__room.disconnect();
        self.chamada = null;
        self.realtime.client.disconnect();
        self.$forceUpdate();
        window.twiliovideo.closeRoom();
    },    
    mounted: function() {
        var self = this;

    }     
} 
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
    #remote-media {
        width: 100%;
        text-align: center;
        height: 100%;
    }

    #remote-media video {
        width: auto !important;
        height: 80vh !important;        
        /*height: 80vh;*/
        /*width: auto;*/
        margin-top: 6px;
    }

    #local-media {
        display: flex;
        position: absolute;
        right: 10px;
        bottom: 10px;
        width: 100px;
        height: 100px;
        background: #000;
        /*border: 1px solid #ddd;*/
    }

    #local-media video {
        width: 100%;
    }


    .chamada-video {
        display: flex;
        align-items: center;
        background-color: #ddd; 
        height: 80vh;   
        position: relative;
        /*background-image: url(/static/images/video-placeholder.png);*/
        /*background-size: 80%;*/
        /*background-position: center;*/
        /*background-repeat: no-repeat;*/
    }

    .chamada-video .placeholder {
        width: 100%;
        opacity: 0.1;
    }

    .chamada-video p {
        text-align: center;
        color: #fff;
        width: 100%;
        padding-left: 20px;
        padding-right: 20px;    
        position: absolute;
    }


    .mute-audio {
        position: absolute;
        bottom: 10px;
        left: 10px;
        background: #59ba92;
        border: 2px solid #ddd;
        border-radius: 50%;
        height: 50px;
        width: 50px;
    }
    .mute-audio i {
        font-size: 30px;
        color: #fff;
        position: relative;
        top: 2px;   
    }

    .mute-video {
        position: absolute;
        bottom: 10px;
        left: 70px;
        background: #59ba92;
        border: 2px solid #ddd;
        border-radius: 50%;
        height: 50px;
        width: 50px;
    }
    .mute-video i {
        font-size: 30px;
        color: #fff;
        position: relative;
        top: 2px;   
    }    

    .page-teleconsulta .dashboard-status-button {
        line-height: 14px;
        font-weight: bold;
    }

</style>



// WEBPACK FOOTER //
// src/components/Teleconsulta.vue